import React from "react";
import Buttons from '../Common/Buttons';
import { useLocale } from '../../localization/LocaleContext';
import '../NicheLanding/NicheLandingPage.css';

const featureIcons = [
    // Overview / pie-chart icon
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21.21 15.89A10 10 0 1 1 8 2.83"/>
        <path d="M22 12A10 10 0 0 0 12 2v10z"/>
    </svg>,
    // Estimate / file-text icon
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
    </svg>,
    // Branding / award icon
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="7"/>
        <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/>
    </svg>,
];

function FeaturesOrganization(){
    const { t } = useLocale();

    const features = [
        { id: 1, icon: featureIcons[0], title: t('organization.sectionOneTitle'), description: t('organization.sectionOneDescription') },
        { id: 2, icon: featureIcons[1], title: t('organization.sectionTwoTitle'), description: t('organization.sectionTwoDescription') },
        { id: 3, icon: featureIcons[2], title: t('organization.sectionThreeTitle'), description: t('organization.sectionThreeDescription') },
    ];

    return(
        <>
            {/* Features */}
            <section className="niche-features sp-90">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <h2 className="h-1 h-bold mb-20">
                                {t('organization.featuresTitleStart')}{' '}{t('organization.featuresTitleEnd')}
                            </h2>
                            <p className="niche-feature-desc" style={{ maxWidth: '600px', margin: '0 auto 20px' }}>
                                {t('organization.intro')}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {features.map(f => (
                            <div className="col-lg-4" key={f.id}>
                                <div className="niche-feature-card">
                                    <div className="niche-feature-icon">{f.icon}</div>
                                    <h3 className="niche-feature-title">{f.title}</h3>
                                    <p className="niche-feature-desc">{f.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="niche-cta-section sp-90">
                <div className="container">
                    <h2 className="h-1 h-bold niche-cta-title">
                        {t('organization.ctaTitle')}
                    </h2>
                    <p className="niche-cta-description">
                        {t('organization.ctaDescription')}
                    </p>
                    <Buttons />
                </div>
            </section>
        </>
    );
}

export default FeaturesOrganization;